import { Navigate, useLocation } from 'react-router-dom';
import { userAppContext } from '../../context/Context';
import { isTrialExpired, mergeTrialAttributes } from '../../utils/trialUtils';
import { useAuthStore } from '../../store/authStore';
import { logTrialEvaluation } from '../../utils/trialDebug';

const UseProtectedRoute = ({ children }) => {
  const { groups, user } = userAppContext();
  const trialAttributes = useAuthStore(state => state.trialAttributes);
  const trialAttributesLoaded = useAuthStore(state => state.trialAttributesLoaded);
  const academicStatus = useAuthStore(state => state.academicStatus);
  const academicActivationDeferred = useAuthStore(state => state.academicActivationDeferred);
  const userType = useAuthStore(state => state.userType);
  const location = useLocation();

  if (groups?.includes('ROLE_TRIAL') && user) {
    const trialUser = mergeTrialAttributes(user, trialAttributes ?? undefined);
    const expired = isTrialExpired(trialUser);
    const deferredAcademicActivation =
      academicStatus === 'approved' && academicActivationDeferred;

    logTrialEvaluation('useProtectedRoute', {
      user,
      trialAttributes,
      trialType: userType,
      extra: {
        pathname: location.pathname,
        trialAttributesLoaded,
        academicStatus,
        academicActivationDeferred,
        deferredAcademicActivation,
        willRedirectToPlans:
          expired && location.pathname !== '/plans' && !deferredAcademicActivation,
        waitingForTrialAttributes: !trialAttributesLoaded,
      },
    });

    if (!trialAttributesLoaded) {
      return children;
    }

    if (expired && location.pathname !== '/plans' && !deferredAcademicActivation) {
      return <Navigate to="/plans" replace />;
    }
  }

  return children;
};

export default UseProtectedRoute;
